import styled, { css } from 'styled-components';

const BaseTableHeadCell = styled.th`
  position: relative;
  font-size: var(--font-body1);
  font-weight: var(--font-bold);
  width: ${({ width }) => width || 'auto'};
  padding: var(--spacing-s) var(--spacing-xs);

  > div {
    display: flex;

    > span {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  ${({ sortable }) => {
    return (
      sortable &&
      css`
        cursor: pointer;

        > div > span {
          max-width: calc(100% - 1rem);
          padding-right: var(--spacing-xs);
        }
      `
    );
  }}

  ${({ align }) => {
    switch (align) {
      case 'center':
        return css`
          > div {
            justify-content: center;
          }
        `;
      default:
        break;
    }
  }}
`;

export default BaseTableHeadCell;
